<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file MainNavigationSearchTop.vue is part of event_pass_client.dev.   -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - MainNavigationSearchTop.vue can not be copied and/or distributed          -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.--><!--//User: keni--><!--//Date: 06/03/2018--><!--//Time: 16:58-->

<template>
    <!--search form-->
    <div class="p-2 bd-highlight d-none d-sm-block">
        <div style="width: 14em;" class="mb-3">
            <!-- Search form -->
            <global_search :content="search"/>
        </div>
    </div>
</template>

<script>
	export default {
		name: "main-navigation-search-top",
		components: {},
		props: ['search'],
		created() {
		},
		destroyed() {
		},
		mounted() {
// console.log('search',this.search);
		},
		data() {
			return {}
		},
		methods: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/nav/MainNavigationSearchTop.vue